import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-49e84fa5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "compilation-greed"
};
const _hoisted_2 = {
  class: "flex-row"
};
const _hoisted_3 = {
  class: "compilation-item2"
};
const _hoisted_4 = {
  key: 0,
  class: "moderation-status"
};
const _hoisted_5 = {
  class: "compilation-item__title"
};
const _hoisted_6 = {
  class: "description"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "compilation-item__links"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Редактировать подборку ");

const _hoisted_10 = ["onClick"];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Копировать ссылку:", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_EditPen = _resolveComponent("EditPen");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_Link = _resolveComponent("Link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$data.Compilations.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.Compilations, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "col-3",
      key: index
    }, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
      to: {
        name: 'profile/compilation',
        params: {
          id: item.id
        }
      },
      append: "",
      class: "compilation-item__img2"
    }, {
      default: _withCtx(() => [item.status_id === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_4, "На модерации")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(item.name) + " ", 1), _createElementVNode("span", _hoisted_6, _toDisplayString(item.description), 1)]), _createElementVNode("img", {
        class: "compilation-item__img2-image",
        src: item.thumbWithPath,
        alt: ""
      }, null, 8, _hoisted_7)]),
      _: 2
    }, 1032, ["to"]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_router_link, {
      to: {
        name: 'profile/compilation-update',
        params: {
          id: item.id
        }
      },
      class: "compilation-edit"
    }, {
      default: _withCtx(() => [_hoisted_9, _createVNode(_component_el_icon, {
        class: "icon-edit"
      }, {
        default: _withCtx(() => [_createVNode(_component_EditPen)]),
        _: 1
      })]),
      _: 2
    }, 1032, ["to"]), _createElementVNode("a", {
      style: {
        "cursor": "pointer"
      },
      class: "compilation-copy",
      onClick: $event => $options.handlerCopy(item.accessLink)
    }, [_createElementVNode("span", null, [_hoisted_11, _createTextVNode(" " + _toDisplayString(item.accessLink), 1)]), _createVNode(_component_el_icon, {
      class: "icon-link"
    }, {
      default: _withCtx(() => [_createVNode(_component_Link)]),
      _: 1
    })], 8, _hoisted_10)])])]);
  }), 128)) : _createCommentVNode("", true)])]);
}